const Radio = {
  parts: ['control'],
  baseStyle: {
    control: {
      bg: 'white',
      border: '1px solid',
      borderColor: 'black',
      _checked: {
        bg: 'white',
        border: '1px solid',
        borderColor: 'black',
        color: 'black',
        _hover: {
          bg: 'white',
          borderColor: 'black',
        },
      },
      _focus: {
        boxShadow: 'none',
      },
    },
  },
  sizes: {
    lg: {
      control: {
        w: '20px',
        h: '20px',
        _checked: {
          _before: {
            h: '12px',
            w: '12px',
          },
        },
      },
    },
    md: {
      control: {
        w: '16px',
        h: '16px',
        _checked: {
          _before: {
            h: '8px',
            w: '8px',
          },
        },
      },
    },
    sm: {
      control: {
        width: '12px',
        height: '12px',
        _checked: {
          _before: {
            h: '6px',
            w: '6px',
          },
        },
      },
    },
  },
};

export default Radio;
